import { first, kebabCase } from 'lodash';

import { CountryCodes } from 'src/common/enums';
import { isWhatsAppEnabled } from 'src/common/hooks/useCountryConfig';

import {
  FIRST_DEFAULT_STEP,
  ONBOARDING_CONFIG_BY_USAGE,
  OnboardingType,
  OnboardingUsage,
  StepNames,
  STEPS_BY_TYPE,
} from '../constants';

export const getStepIndex = (steps: StepNames[], StepName: StepNames) =>
  steps.findIndex((step) => step === StepName);

export const getOnboardingRedirectURL = (
  lastStep: StepNames = FIRST_DEFAULT_STEP
) => {
  const { route } =
    ONBOARDING_CONFIG_BY_USAGE[OnboardingUsage.OnboardingGuided];
  return `/${route}/${kebabCase(lastStep)}`;
};

export const getOnboardingType = (
  countryCode: CountryCodes,
  whatsappNumber?: string
) => {
  const showWhatsappForm = isWhatsAppEnabled(countryCode) && !whatsappNumber;
  if (showWhatsappForm) {
    return OnboardingType.JobSeekerShortenedWithWhatsapp;
  }

  return OnboardingType.JobSeekerShortened;
};

export const isLastStepMatchInitialStepInOnboardingType = (
  lastStep: StepNames,
  onboardingType: OnboardingType
): boolean => {
  if (!onboardingType) {
    return true;
  }

  const steps = STEPS_BY_TYPE[onboardingType];
  return first(steps) === lastStep;
};
